import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import colors from '@app/constants/colors';
import { languages } from '@app/constants/localization';
import { toggleLocale } from '@app/actions/localeActions';

const LanguageSwitch = ({ locale, toggleLocale, isShowOnSmall }) => (
  <LanguageSwitchContainer isShowOnSmall={isShowOnSmall}>
    <FormattedMessage id="header.english" />
    <SwitchContainer onClick={toggleLocale}>
      <Switch locale={locale} />
    </SwitchContainer>
    <FormattedMessage id="header.arabic" />
  </LanguageSwitchContainer>
);

LanguageSwitch.propTypes = {
  isShowOnSmall: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  toggleLocale: PropTypes.func.isRequired,
};

LanguageSwitch.defaultProps = {
  isShowOnSmall: false,
};

const CONTAINER_HEIGHT = 23;
const CONTAINER_WIDTH = 48;
const CONTAINER_BORDER = 1;
const SWITCH_HEIGHT = 27;

const LanguageSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.CERULEAN};
  font-size: 15px;
  @media (max-width: 399px) {
    display: ${({ isShowOnSmall }) => (isShowOnSmall ? 'flex' : 'none')};
  }
`;

const SwitchContainer = styled.div`
  width: 48px;
  height: ${CONTAINER_HEIGHT}px;
  border-radius: 20px;
  position: relative;
  border: 1px solid ${colors.CERULEAN};
  background-color: ${colors.HAWKES_BLUE};
  margin: 0 10px;
  cursor: pointer;
`;

const Switch = styled.div`
  width: ${SWITCH_HEIGHT}px;
  height: ${SWITCH_HEIGHT}px;
  border-radius: 50%;
  position: absolute;
  background-color: ${colors.CERULEAN};
  top: ${(CONTAINER_HEIGHT - SWITCH_HEIGHT) / 2 - CONTAINER_BORDER}px;
  left: ${({ locale }) => (locale === languages.EN ? `${-CONTAINER_BORDER - 1}px` : `${CONTAINER_WIDTH - SWITCH_HEIGHT}px`)};
`;

const mapStateToProps = ({ intl }) => ({
  locale: intl.locale,
});

const mapDispatchToProps = {
  toggleLocale,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitch);
